const RolesHelper = {
    admin: { title: 'Администратор', key: 'admin' },
    all_staff: { title: 'Сотрудники - все', key: 'all_staff' },
    authenticate: { title: 'Доступ к системе', key: 'authenticate' },
    calendar_full_access: { title: 'Полный доступ к Календарь доступности сотрудников', key: 'calendar_full_access' },
    calendar_view: { title: 'Просмотр Календарь доступности сотрудников', key: 'calendar_view' },
    cash_chief_accountant: { title: 'Главный Бухгалтер', key: 'cash_chief_accountant' },
    cash_director: { title: 'Кассы - Директор', key: 'cash_director' },
    cash_office_accountant: { title: 'Бухгалтер офиса', key: 'cash_office_accountant' },
    companies_by_employer: { title: 'Контакты и компании сотрудника', key: 'companies_by_employer' },
    companies_by_office: { title: 'Контакты и компании по офису', key: 'companies_by_office' },
    companies_full_access: { title: 'Контакты и компании – полный доступ', key: 'companies_full_access' },
    companies_read: { title: 'Контакты и компании – только просмотр', key: 'companies_read' },
    deal_ceo: { title: 'Генеральный директор - сделка', key: 'deal_ceo' },
    deal_chief_technologist: { title: 'Главный технолог - сделка', key: 'deal_chief_technologist' },
    deal_financial_director: { title: 'Финансовый директор - сделка', key: 'deal_financial_director' },
    deal_head_installation: { title: 'Начальник монтажа - сделка', key: 'deal_head_installation' },
    deal_head_service: { title: 'Начальник сервиса - сделка', key: 'deal_head_service' },
    deal_installer: { title: 'Установщик - сделка', key: 'deal_installer' },
    deal_manager: { title: 'Менеджер - сделка', key: 'deal_manager' },
    deal_measurer: { title: 'Замерщик - сделка', key: 'deal_measurer' },
    deal_office_manager: { title: 'Руководитель офиса - сделка', key: 'deal_office_manager' },
    debt_all: { title: 'Долги все', key: 'debt_all' },
    debt_assembly_department: { title: 'Долги монтажного отдела', key: 'debt_assembly_department' },
    debt_cashless: { title: 'Долги безнал', key: 'debt_cashless' },
    debt_own: { title: 'Свои долги', key: 'debt_own' },
    debt_service_department: { title: 'Долги сервисного отдела', key: 'debt_service_department' },
    head_office: { title: 'Руководитель офисов', key: 'head_office' },
    lead_by_office: { title: 'Лиды по офису', key: 'lead_by_office' },
    lead_full_access: { title: 'Полнывй доступ к лидам', key: 'lead_full_access' },
    lead_responsible: { title: 'Ответсвенный по лиду', key: 'lead_responsible' },
    lead_status_change: { title: 'Лиды смена статуса', key: 'lead_status_change' },
    log_lead_view: { title: 'Просмотр лога Лидов', key: 'log_lead_view' },
    log_system_view: { title: 'Просмотр лога истории Сделки', key: 'log_system_view' },
    log_sms_view: { title: 'Просмотр лога СМС', key: 'log_sms_view' },
    map_full_access: { title: 'Полный доступ к карте замеров', key: 'map_full_access' },
    map_view: { title: 'Просмотр Карты замеров', key: 'map_view' },
    installation_map_full_access: { title: 'Полный доступ к карте монтажа', key: 'installation_map_full_access' },
    installation_map_view: { title: 'Просмотр Карты монтажа', key: 'installation_map_view' },
    office_manager: { title: 'Руководитель офиса', key: 'office_manager' },
    office_staff: { title: 'Сотрудники офиса', key: 'office_staff' },
    operation_cashless: { title: 'Операции безнал', key: 'operation_cashless' },
    operation_employer: { title: 'Операции сотрудника', key: 'operation_employer' },
    operation_full_access: { title: 'Операции – Полный доступ', key: 'operation_full_access' },
    operation_full_access_except_expense_confirm: { title: 'Операции – Полный доступ кроме подтверждения расхода', key: 'operation_full_access_except_expense_confirm' },
    operation_office_accountant: { title: 'Бухгалтер офиса', key: 'operation_office_accountant' },
    right_setup: { title: 'Настройка прав', key: 'right_setup' },
    task_by_employer: { title: 'Задачи по сотруднику', key: 'task_by_employer' },
    task_by_office: { title: 'Задачи по офису', key: 'task_by_office' },
    task_full_access: { title: 'Задачи полный доступ', key: 'task_full_access' },
    timesheet_installers_self: { title: 'Установщики - сотрудник', key: 'timesheet_installers_self' },
    timesheet_installers_all: { title: 'Установщики - полный доступ', key: 'timesheet_installers_all' },
    timesheet_measurers_self: { title: 'Замерщики - сотрудник', key: 'timesheet_measurers_self' },
    timesheet_measurers_all: { title: 'Замерщики - полный доступ', key: 'timesheet_measurers_all' },
    timesheet_managers_self: { title: 'Менеджеры - сотрудник', key: 'timesheet_managers_self' },
    timesheet_managers_all: { title: 'Менеджеры - полный доступ', key: 'timesheet_managers_all' },
    analytics_employers_rating: { title: 'Рейтинг', key: 'analytics_employers_rating' },
    analytics_employers_plan_full: { title: 'План сотрудников - полный доступ', key: 'analytics_employers_plan_full' },
    analytics_employers_plan_view: { title: 'План сотрудников - просмотр', key: 'analytics_employers_plan_view' },
    analytics_deal_profit: { title: 'Доходность сделки', key: 'analytics_deal_profit' },
    incomes_all: { title: 'Приходы списки все', key: 'incomes_all' },
    incomes_employer: { title: 'Приходы списки по сотруднику', key: 'incomes_employer' },
    incomes_cash_director: { title: 'Приходы @ - директор', key: 'incomes_cash_director' },
    incomes_cash_employer: { title: 'Приходы @ - сотрудник', key: 'incomes_cash_employer' },
    incomes_cashless_accountant: { title: 'Приходы безнал - бухгалтер', key: 'incomes_cashless_accountant' },
    incomes_cashless_employer: { title: 'Приходы безнал - сотрудник', key: 'incomes_cashless_employer' },
    expenses_all: { title: 'Расходы - полный доступ', key: 'expenses_all' },
    expenses_registry_employers: { title: 'Реестр по сотрудникам', key: 'expenses_registry_employers' },
    references_contractors: { title: 'Контрагенты - полный доступ', key: 'references_contractors' }
};

export default RolesHelper;

/*
Пример проверки на роль
 Object.prototype.hasOwnProperty.call(this.$store.state.auth.roles, RolesHelper.lead_full_access);
 */
